import { useRef } from "react";
import {observer} from "mobx-react";

import classNames from "classnames";
import styles from "./styles/_BlockCS.module.scss";

import dynamic from 'next/dynamic';
import ErrorBlock from "../SchoolBlocks/ErrorBlock";

export const enum ITerraceTypes {
    EVENTS = "events",
    NEWS = "news",
    MEDIA = "media",
    ABOUT = "about",
    MAP = "map",
    HTML = "html",
    FILES = "files",
    HERO = "hero",
}

const blockTypes = {
    [ITerraceTypes.MAP]: dynamic(() => import("./MapBlock/MapBlock")),
    [ITerraceTypes.EVENTS]: dynamic(() => import("./EventsBlock/EventsBlock")),
    [ITerraceTypes.ABOUT]: dynamic(() => import("./AboutBlock/AboutBlock")),
    [ITerraceTypes.HTML]: dynamic(() => import("./HTMLBlock/HTMLBlock")),
    [ITerraceTypes.NEWS]: dynamic(() => import("./NewsBlock/NewsBlock")),
};

const Block = observer((props: {
    blockObj: ITerraceBlock,
}) => {
    const blockRef = useRef<HTMLElement | null>(null);

    const BlockTypeComponent = blockTypes[props.blockObj.type] || ErrorBlock;

    const blockClassName = classNames({
        [styles.block]: true,
        [styles.blockPadded]: props.blockObj.type !== ITerraceTypes.MAP,
        [styles.typeNewsstream]: props.blockObj.type === ITerraceTypes.NEWS,
        [styles.typeEventlist]: props.blockObj.type === ITerraceTypes.EVENTS,
    });

    return (
        <article
            className={blockClassName}
            data-id={props.blockObj.id}
            data-block-type={props.blockObj.type}
            ref={blockRef}
        >
            <BlockTypeComponent blockObj={props.blockObj} />
        </article>
    );
});

export default Block;
